//图片尺寸
export const imgSizeList_zh = [
  require('./images/size1.png'),
  require('./images/size2.png'),
  require('./images/size3.png'),
  require('./images/size4.png'),
  require('./images/size5.png'),
  require('./images/size6.png'),
];
export const imgSizeList_en = [
  require('./images/size1_en.png'),
  require('./images/size2_en.png'),
  require('./images/size3_en.png'),
  require('./images/size4_en.png'),
  require('./images/size5_en.png'),
  require('./images/size6_en.png'),
];
